import forumEnums from '../store/models/forumEnums';
import userEnums from '../store/models/user';


const userCheck = function(user) {
    if (user.status === userEnums.statusEnum.BANNED) return false;
    if (user.status === userEnums.statusEnum.BLOCKED) return false;
    if (user.status === userEnums.statusEnum.REGISTERING) return false;

    return true;
};

const boards = {
    create: function(user) {
        return user.isForumAdmin();
    },
    update: function(user) {
        return user.isForumAdmin();
    },
    delete: function(user) {
        return user.isForumAdmin();
    },
    read: function(user, boardType, boardStatus) {
        if (boardStatus === forumEnums.boardStatusEnum.INACTIVE && !user.isForumAdmin()) return false;
        if (boardType === forumEnums.boardTypeEnum.STANDARD) return true;
        if (boardType === forumEnums.boardTypeEnum.MEMBER) return true;
        if (boardType === forumEnums.boardTypeEnum.NEWS) return true;
        if (boardType === forumEnums.boardTypeEnum.VIP && user.isVIP()) return true;
        if (boardType === forumEnums.boardTypeEnum.EDITOR && user.isEditor()) return true;
        if (boardType === forumEnums.boardTypeEnum.MODERATOR && user.isModerator()) return true;
        if (boardType === forumEnums.boardTypeEnum.ADMIN && user.isForumAdmin()) return true;
        if (boardType === forumEnums.boardTypeEnum.COREADMIN && user.isCoreAdmin()) return true;
        return false;
    }
};

const topics = {

    hide: function(user) {
        if (!userCheck(user)) return false;
         return user.isModerator();
    },

    create: function(user, boardType, boardStatus) {
        if (!userCheck(user)) return false;

        if (boardType === forumEnums.boardTypeEnum.COREADMIN && !user.isCoreAdmin()) return false;
        if (boardType === forumEnums.boardTypeEnum.ADMIN && !user.isForumAdmin()) return false;
        if (boardType === forumEnums.boardTypeEnum.MODERATOR && !user.isModerator()) return false;
        if (boardType === forumEnums.boardTypeEnum.EDITOR && !user.isEditor()) return false;
        if (boardType === forumEnums.boardTypeEnum.VIP && !user.isVIP()) return false;
        if (boardType === forumEnums.boardTypeEnum.NEWS && !user.isForumAdmin()) return false;

        if (boardStatus === forumEnums.boardStatusEnum.ARCHIVED && !user.isModerator()) return false;
        if (boardStatus === forumEnums.boardStatusEnum.INACTIVE && !user.isForumAdmin())  return false;

        return true;
    },
    update: function(user, owningMemberID) {
        if (!userCheck(user)) return false;

        if (user.isEditor()) return true;

        return user.id === owningMemberID;
    },
    setStatus: function(user) {
        if (!userCheck(user)) return false;

        return user.isModerator();
    },
    delete: function(user, owningMemberID) {
        if (!userCheck(user)) return false;

        if (user.isEditor() && user.id === owningMemberID) return true;

        return user.isModerator();
    },
    read: function(user, boardType, boardStatus, topicStatus) {
        if (!boards.read(user, boardType, boardStatus)) return false;

        if (topicStatus === forumEnums.topicStatusEnum.DELETED && !user.isForumAdmin()) return false;
        if (topicStatus === forumEnums.topicStatusEnum.PENDINGAPPROVAL && !user.isModerator()) return false;

        return true;
    },
    getStatus: function(user, boardType, moderationThreshold) {
        if (!userCheck(user)) return forumEnums.topicStatusEnum.PENDINGAPPROVAL;

        // news boards should always be moderated
        if (boardType === forumEnums.boardTypeEnum.NEWS && !user.isVIP()) return forumEnums.topicStatusEnum.PENDINGAPPROVAL;

        if (!user.isMemberOf(moderationThreshold)) {
            return forumEnums.topicStatusEnum.PENDINGAPPROVAL;
        } else {
            return forumEnums.topicStatusEnum.NORMAL;
        }
    }
};



const posts = {
    create: function(user, boardType, boardStatus, topicStatus) {
        if (!userCheck(user)) return false;

        if (!topics.read(user, boardType, boardStatus)) return false;

        if (topicStatus === forumEnums.topicStatusEnum.LOCKED && !user.isModerator()) return false;
        if (topicStatus === forumEnums.topicStatusEnum.DELETED && !user.isModerator()) return false;

        return true;
    },
    update: function(user, boardType, boardStatus, topicStatus, owningMemberID) {
        if (!posts.create(user, boardType, boardStatus, topicStatus)) return false;

        if (user.id === owningMemberID) return true;

        return user.isEditor();
    },
    delete: function(user, boardType, boardStatus, topicStatus, owningMemberID) {

        if (!userCheck(user)) return false;
        if (!topics.read(user, boardType, boardStatus)) return false;

        if (user.isEditor() && user.id === owningMemberID) return true;

        return user.isModerator();
    },
    report: function(user) {
        return userCheck(user);
    },
    approve: function(user) {
        if (!userCheck(user)) return false;
        return user.isModerator();
    },
    hide: function(user) {
        if (!userCheck(user)) return false;
        return user.isModerator();
    },
    deny: function(user) {
        if (!userCheck(user)) return false;
        return user.isModerator();
    },
    viewPendingApproval: function(user) {
        if (!userCheck(user)) return false;
        return user.isModerator();
    },
    viewDenied: function(user) {
        if (!userCheck(user)) return false;
        return user.isModerator();
    },
    viewDeleted: function(user) {
        if (!userCheck(user)) return false;
        return user.isModerator();
    },
    getStatus: function(user, topicStatus) {
        if (!userCheck(user)) return forumEnums.postStatusEnum.DENIED;

        if (topicStatus === forumEnums.topicStatusEnum.DELETED && !user.isForumAdmin()) return forumEnums.postStatusEnum.DENIED;
        if (topicStatus === forumEnums.topicStatusEnum.LOCKED && !user.isModerator()) return forumEnums.postStatusEnum.DENIED;
        if (topicStatus === forumEnums.topicStatusEnum.MODERATED && !user.isVIP()) return forumEnums.postStatusEnum.PENDINGAPPROVAL;

        return forumEnums.postStatusEnum.APPROVED;
    },
    requiresApproval: function(user, topicStatus) {
        if (!userCheck(user)) return true;
        if (topicStatus === forumEnums.topicStatusEnum.MODERATED) {
            return !user.isVIP();
        } else {
            return false;
        }
    }
};

const attachments = {
    canDownload: function(user) {
        return userCheck(user);
    }
};

export default {
    boards: boards,
    topics: topics,
    posts: posts,
    attachments: attachments
};
